<template>
    <div class="custom-select">
        <div class="grid gap-2.5" :style="{ gridTemplateColumns: `repeat(${columns}, 1fr)` }">
            <ActionButton
                v-for="(option, index) in options"
                :key="index"
                @click="updateValue(option.value)"
                size="small"
                class="text-sm uppercase"
                :class="[
                    index === 0
                        ? 'clip-right-corner'
                        : index + 1 === columns
                          ? 'clip-left-corner'
                          : 'clip-both-corners',
                ]"
                :muted="modelValue != option.value"
            >
                <div class="flex items-center justify-center">
                    <p>
                        {{ option.label }}
                    </p>
                </div>
            </ActionButton>
        </div>
    </div>
</template>

<script>
import ActionButton from '@/components/ui/ActionButton.vue'

export default {
    name: 'CustomSelect',
    components: {
        ActionButton,
    },
    props: {
        modelValue: {
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    computed: {
        columns() {
            return this.options.length
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value)
        },
    },
}
</script>

<style scoped>
.custom-select select {
    padding: 0.5rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 1rem;
}
</style>
